import React from "react";
import { DialogTitle, TextField } from "@mui/material";

const EditDealer = (props) => {
  const { formik } = props;

  return (
    <>
      <DialogTitle sx={{ textAlign: "center" }}>Update Dealer</DialogTitle>

      <div className="grid grid-cols-1 gap-4 p-2">
        <TextField
          type="text"
          fullWidth
          id="dealerName"
          label="Dealer Name"
          value={formik.values.dealer.name}
          onChange={formik.handleChange("dealer.name")}
        />
        <TextField
          type="text"
          fullWidth
          id="dealerAddress"
          label="Dealer Address"
          value={formik.values.dealer.address}
          onChange={formik.handleChange("dealer.address")}
        />
        <TextField
          type="text"
          fullWidth
          id="dealerEmail"
          label="Dealer Email"
          value={formik.values.dealer.email}
          onChange={formik.handleChange("dealer.email.0")}
        />
        <TextField
          type="text"
          fullWidth
          id="dealerContact"
          label="Dealer Contact"
          value={formik.values.dealer.contact}
          onChange={formik.handleChange("dealer.contact.0")}
        />
      </div>
    </>
  );
};

export default EditDealer;
